import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Routes } from "./routes";

ReactDOM.render(<Routes />, document.getElementById("myApp"));
